'use client';

import * as ProgressPrimitive from '@radix-ui/react-progress';
import * as React from 'react';

import { cn } from '../../lib/cn';

export interface ProgressProps extends React.ComponentPropsWithoutRef<
	typeof ProgressPrimitive.Root
> {
	/** Percentuale di avanzamento (0-100). Se assente viene trattata come 0. */
	value?: number;
}

/** Barra di avanzamento lineare (es. percentuale di completamento onboarding, progresso di un caricamento). */
const Progress = React.forwardRef<React.ElementRef<typeof ProgressPrimitive.Root>, ProgressProps>(
	({ className, value, ...props }, ref) => (
		<ProgressPrimitive.Root
			ref={ref}
			className={cn('relative h-[5px] w-full overflow-hidden rounded-[3px] bg-border', className)}
			{...props}
		>
			<ProgressPrimitive.Indicator
				className="h-full w-full flex-1 rounded-[3px] bg-gradient-to-r from-accent-green to-accent transition-all"
				style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
			/>
		</ProgressPrimitive.Root>
	),
);
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
